import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Observable} from "rxjs/Observable";

@Injectable()
export class SnowridersService {
  private _showLogo: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  showLogo: Observable<boolean> = this._showLogo.asObservable();

  setLogoVisibility(value: boolean) {
    this._showLogo.next(value);
  }
}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/snowriders.service.ts